<div [style.justify-content]="aligment === 'center' ? 'center' : (aligment === 'right' ? 'flex-end' : 'flex-start')"
     class="flex flex-row gap-x-2 w-full">
  @if (header && aligment === 'right') {
    <div [class.flex-1]="headerFull" class="my-auto flex-shrink-0">
      <ng-container *ngTemplateOutlet="header"></ng-container>
    </div>
  }
  <div [class.flex-1]="!headerFull" [class.min-w-0]="headerFull" class="flex flex-row gap-x-2 items-center">
    <!-- Flecha izquierda -->
    @if (canScrollLeft) {
      <button (click)="scrollTabs('left')"
              class="btn p-2 flex-shrink-0"
              type="button"
              style="border-radius: 0">
        <img alt="icon" class="filter-neutral-800 !h-5" src="/assets/icons/feather/chevron-left.svg">
      </button>
    }

    <!-- Contenedor de tabs -->
    <div #tabsContainer
         (scroll)="onScroll()"
         [class.justify-center]="aligment === 'center'"
         [class.justify-end]="aligment === 'right'"
         [class.justify-start]="aligment === 'left'"
         class="flex flex-row gap-x-2 overflow-x-auto tabs-scroll flex-1 min-w-0">
      @for (tab of config; track tab.slug) {
        <button (click)="changeTab(tab)"
                [disabled]="tab.disabled"
                [class.!border-b-2]="currentTab === tab.slug"
                class="btn p-2 cd-text-md font-medium border-primary-800 transition-all duration-300 my-auto flex-shrink-0"
                [class.opacity-50]="tab.disabled"
                [class.pointer-events-none]="tab.disabled"
                type="button"
                style="border-radius: 0">
          @if (labelTemplate) {
            <ng-container
              *ngTemplateOutlet="labelTemplate; context: {$implicit: tab, selected: currentTab === tab.slug}"></ng-container>
          } @else {
            <span class="truncate">{{ tab.label }}</span>
          }
        </button>
      }
    </div>

    @if (canScrollRight) {
      <button (click)="scrollTabs('right')"
              class="btn p-2 flex-shrink-0"
              type="button"
              style="border-radius: 0">
        <img alt="icon" class="filter-neutral-800 !h-5" src="/assets/icons/feather/chevron-right.svg">
      </button>
    }
  </div>

  @if (header && aligment === 'left') {
    <div [class.flex-1]="headerFull" class="my-auto flex-shrink-0">
      <ng-container *ngTemplateOutlet="header"></ng-container>
    </div>
  }
</div>

<div #contentContainer [style.min-height.px]="contentMinHeight || null" class="relative w-full">
  @for (tab of config; track tab.slug) {
    @if (tab.template && isTabRendered(tab.slug)) {
      <div
        [class.relative]="currentTab === tab.slug"
        [class.opacity-100]="currentTab === tab.slug"
        [class.pointer-events-auto]="currentTab === tab.slug"
        [class.static]="currentTab === tab.slug"
        [class.translate-x-0]="currentTab === tab.slug"
        [class.absolute]="currentTab !== tab.slug"
        [class.invisible]="currentTab !== tab.slug"
        [class.opacity-0]="currentTab !== tab.slug"
        [class.pointer-events-none]="currentTab !== tab.slug"
        [class.translate-x-1]="currentTab !== tab.slug"
        class="left-0 top-0 w-full transition-all duration-300 ease-in-out">
        <ng-container *ngTemplateOutlet="tab.template; context: {$implicit: tab.slug || ''}"></ng-container>
      </div>
    }
  }
</div>
